import { Box, Chip, ContentPanel, TableContainer, Text, variables } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { REFRESH_BANNER_HEIGHT } from '../../constants/layout';

export const AlertsContainer = styled(Box)`
  display: flex;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: #fff;

  .MuiTableCell-root {
    padding: 26px 10px;
  }
`;

export const AlertsTablePanel = styled(ContentPanel)`
  width: 100%;
  padding: ${REFRESH_BANNER_HEIGHT}px 0 0 16px;

  table {
    border-collapse: collapse;
  }
`;

export const ServiceChip = styled(Chip)`
  height: 23px;
  padding: 6px 10px;
  border-radius: 4px;
  border: 1px solid var(--plum-oulineBorder, rgba(255, 127, 254, 0.5));
  background: var(--plum-950, #fce6ff);
  color: var(--plum-dark, #992881);
`;

export const DataTableContainer = styled(TableContainer)<{ minHeight?: string; top: number }>`
  height: auto;
  min-height: ${(props) => props.minHeight || 'auto'};
  overflow: initial;
  overscroll-behavior: none;

  thead {
    th {
      top: ${(props) => props.top}px;
      padding: 16px 24px 16px 16px;
      border-bottom: 1px solid ${variables.color.neutralvariant90};
    }
  }
  tbody {
    td {
      border-bottom: 1px solid ${variables.color.neutralvariant90};
    }
  }
`;

export const ReassignNameText = styled(Text)`
  color: var(--text-primary, #242526);
`;

export const ReassignText = styled(Text)`
  color: var(--text-secondary, #5c5e61);
`;
